export default __webpack_public_path__ + "event-summary-blob-1.svg";